export default "__VITE_ASSET__87f2b34a__"